import DeliveryTruckIconPath from "@ingka/ssr-icon/paths/delivery-truck";

export default DeliveryTruckIconPath;
